import React from 'react';
import { get } from 'lodash';

import Schema from '../../../../../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
import { getLocalstorageToken } from '../../../../../../../context/AuthHelper';
import DrittmittelVN, { GetVNDrittmittelFormStruc } from './DrittmittelVN';
const P = Schema.attributes;

export const GetDrittmittelVN = (application: any, kostenKategories: any) => {
	const OrgaStruc = [
		{
			label: 'Antragsteller',
			content: <DrittmittelVN kostentraeger="Antragsteller" unternehmenId={get(getLocalstorageToken(), 'organisationId')} />,
			formStruc: GetVNDrittmittelFormStruc(
				application,
				get(getLocalstorageToken(), 'organisationId'),
				'Antragsteller',
				kostenKategories,
			),
		},
	];
	const PartnerStruc = get(application, P.Zuwendungsantrag.schema.attributes.Partner.path, []).map((ele: any, i: number) => {
		return {
			label: `Partner ${i + 1}`,
			content: <DrittmittelVN kostentraeger="Projektpartner" unternehmenId={get(ele, 'Unternehmen.id')} />,
			formStruc: GetVNDrittmittelFormStruc(application, get(ele, 'Unternehmen.id'), 'Projektpartner', kostenKategories),
		};
	});
	return [...OrgaStruc, ...PartnerStruc];
};
